import { ImgHTMLAttributes } from 'react';
import { useAsset } from '@/utils/asset';

export default function AppLogoIcon(props: ImgHTMLAttributes<HTMLImageElement>) {
    const asset = useAsset();
    return (
        <>
            {/* Light mode logo */}
            <img
                {...props}
                src={asset('logos/hk-logo.png')}
                alt="Kautionskonto Logo"
                className={`object-contain dark:hidden ${props.className || ''}`}
                style={{
                    aspectRatio: 'auto',
                    ...props.style,
                }}
            />

            {/* Dark mode logo */}
            <img
                {...props}
                src={asset('logos/hk-logo-dark.png')}
                alt="Kautionskonto"
                className={`hidden object-contain dark:block ${props.className || ''}`}
                style={{
                    aspectRatio: 'auto',
                    ...props.style,
                }}
            />
        </>
    );
}
